/*
  Suivi de comportement EduBark (projet edubark/projects/tracking-comportement/), sur les advertoriaux et
  les fiches produit choisies dans snippets/suivi-comportement.liquid (qui donne data-page et data-type).
  Note, pour chaque visite : la pub d'origine, la profondeur de lecture, le temps passé sur chaque section
  et le bouton : clic vers la fiche sur un advertorial, ajout au panier sur une fiche. Aucune donnée personnelle.

  Pub d'origine : lue dans l'URL d'arrivée (Meta y ajoute ad_id, campaign_id, utm_* ; Google Ads gclid et
  gad_campaignid, notés source google_ads) et gardée 14 jours
  dans le navigateur, pour que la fiche visitée après l'advertorial, ou le lendemain, garde la même pub.

  Envoi : un état cumulatif de la visite (pas un flux d'événements), renvoyé au serveur
  quand il change, au plus toutes les 10 s, et à la sortie de page (sendBeacon).
  Le serveur garde la valeur la plus haute de chaque compteur, un envoi perdu ne coûte donc rien.

  Lien avec les commandes : l'identifiant du visiteur et de la visite est posé dans le panier Shopify
  (attributs cachés _suivi_vid et _suivi_sid). Il suit la commande jusqu'au paiement, et le webhook
  orders/paid le renvoie au serveur.

  Exclure ses propres visites : ouvrir une fois la page avec ?suivi=off (?suivi=on pour annuler).
*/
(function () {
  var script = document.currentScript;
  var ENDPOINT = script && script.getAttribute('data-endpoint');
  // Navigateur piloté par un robot (Puppeteer, Selenium, etc.) : pas une vraie visite. Les bots qui viennent
  // d'un centre de données sans le déclarer sont écartés par le serveur.
  if (!ENDPOINT || !window.fetch || navigator.webdriver) return;

  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function get(s, k) { try { return s && s.getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { s && s.setItem(k, v); } catch (e) {} }
  function rid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }

  var params = new URLSearchParams(location.search);
  if (params.get('suivi') === 'off') set(LS, 'edb-adv-test', '1');
  if (params.get('suivi') === 'on') try { LS && LS.removeItem('edb-adv-test'); } catch (e) {}

  var PAGE = (script.getAttribute('data-page') || location.pathname).slice(0, 200);
  var TYPE = script.getAttribute('data-type') || 'advertorial';
  var vid = get(LS, 'edb-adv-vid') || rid(); set(LS, 'edb-adv-vid', vid);
  var SKEY = 'edb-adv-state:' + PAGE;
  var state = null;
  try { state = JSON.parse(get(SS, SKEY) || 'null'); } catch (e) {}

  if (!state) {
    var p = function (k) { return params.get(k) || null; };
    var AD_FIELDS = ['ad_id', 'adset_id', 'campaign_id', 'fbclid', 'utm_source', 'utm_campaign', 'utm_content', 'placement'];
    var ad = null;
    // Clic Google Ads (gclid, gbraid, wbraid, gad_campaignid), sans pub Meta : source google_ads + ID de campagne.
    var google = !p('ad_id') && !p('fbclid') && (p('gclid') || p('gbraid') || p('wbraid') || p('gad_campaignid'));
    if (google) {
      ad = { at: Date.now(), utm_source: 'google_ads', utm_campaign: p('gad_campaignid') };
      set(LS, 'edb-adv-pub', JSON.stringify(ad));
    } else if (p('ad_id') || p('fbclid') || p('utm_source')) {
      ad = { at: Date.now() };
      AD_FIELDS.forEach(function (k) { ad[k] = k === 'placement' ? p('placement') || p('utm_medium') : p(k); });
      set(LS, 'edb-adv-pub', JSON.stringify(ad));
    } else {
      try { ad = JSON.parse(get(LS, 'edb-adv-pub') || 'null'); } catch (e) {}
      if (ad && Date.now() - ad.at > 14 * 86400000) ad = null;
    }
    state = {
      sid: rid(), vid: vid, page: PAGE, started: Date.now(),
      referrer: document.referrer || null,
      device: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
      vw: window.innerWidth, vh: window.innerHeight,
      depth: 0, active_ms: 0, sections: {}, cta: 0, cta_ms: null
    };
    AD_FIELDS.forEach(function (k) { state[k] = ad ? ad[k] || null : null; });
  }
  state.test = get(LS, 'edb-adv-test') === '1' ? 1 : 0;

  // Sections de la page : chaque section Shopify du template (id="shopify-section-template--…__cle").
  // Sur une fiche, le header, la barre d'annonce et le footer (sections de groupe) ne comptent pas.
  var SEL = TYPE === 'advertorial' ? '[id^="shopify-section-"]' : '[id^="shopify-section-template--"]';
  var CTA_SEL = TYPE === 'advertorial' ? '.adv-btn' : 'form[action*="/cart/add"], .ebk-os__atc, .volume-offer__submit, .ebk-lp-offer__buy';
  // Texte visible d'un élément, sans le CSS ni le JS des balises <style>/<script> que le thème met dans ses sections.
  var CODE_SEL = 'style, script, noscript, template';
  function textOf(el) {
    if (el.tagName === 'VIDEO') return 'Vidéo';
    if (!el.querySelector || !el.querySelector(CODE_SEL)) return (el.textContent || '').replace(/\s+/g, ' ').trim();
    var c = el.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll(CODE_SEL), function (n) { n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  // Page codée à la main sans sections Shopify (landing d'Alexandre, layout none) : ses <section id> de premier niveau.
  var SEL_MAIN = 'section[id]:not(section section)';
  function sectionNodes() {
    var nodes = document.querySelectorAll(SEL);
    if (!nodes.length && TYPE === 'landing') { SEL = SEL_MAIN; nodes = document.querySelectorAll(SEL); }
    return Array.prototype.slice.call(nodes).map(function (el) {
      var h = el.querySelector('h1, h2, h3');
      // Section sans intertitre : le début de son texte sert de nom dans le dashboard.
      var txt = textOf(h || el);
      return { el: el, key: el.id.split('__').pop(), title: h || txt.length <= 60 ? txt.slice(0, 120) : txt.slice(0, 60) + '…' };
    }).filter(function (s) { return s.el.offsetHeight > 0 && getComputedStyle(s.el).display !== 'none'; });
  }
  var SECTIONS = [];

  // Zone de lecture : l'article lui-même (la colonne d'annonces à droite ne compte pas dans la hauteur).
  function docHeight() { return Math.max(document.documentElement.scrollHeight, document.body.scrollHeight); }
  function depthNow() {
    var h = docHeight();
    return h ? Math.min(1, (window.scrollY + window.innerHeight) / h) : 0;
  }

  // Structure de la page (ordre, intertitre, position) : envoyée avec chaque état, le serveur la garde par page.
  function layout() {
    var h = docHeight();
    return SECTIONS.map(function (s) {
      var r = s.el.getBoundingClientRect();
      return { key: s.key, title: s.title, cta: !!s.el.querySelector(CTA_SEL), top: +((r.top + window.scrollY) / h).toFixed(4), bottom: +((r.bottom + window.scrollY) / h).toFixed(4) };
    });
  }

  // Chaque seconde où la page est visible et l'utilisateur actif (geste dans les 30 dernières s),
  // la seconde est créditée à la section qui occupe le milieu de l'écran.
  var lastGesture = Date.now();
  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(function (ev) {
    window.addEventListener(ev, function () { lastGesture = Date.now(); }, { passive: true });
  });
  var dirty = true;

  function tick() {
    if (document.visibilityState !== 'visible' || Date.now() - lastGesture > 30000) return;
    state.active_ms += 1000;
    var mid = window.innerHeight / 2;
    for (var i = 0; i < SECTIONS.length; i++) {
      var r = SECTIONS[i].el.getBoundingClientRect();
      if (r.top <= mid && r.bottom > mid) {
        var k = SECTIONS[i].key;
        state.sections[k] = (state.sections[k] || 0) + 1000;
        break;
      }
    }
    var d = depthNow();
    if (d > state.depth) state.depth = +d.toFixed(4);
    dirty = true;
  }

  window.addEventListener('scroll', function () {
    var d = depthNow();
    if (d > state.depth + 0.005) { state.depth = +d.toFixed(4); dirty = true; }
  }, { passive: true });

  // Chaque clic (lien ou non) pour la heatmap : section, chemin de l'élément cliqué dans la section
  // (indices d'enfants, le même HTML sur mobile et desktop) et position du clic dans cet élément.
  // Advertorial : un clic sur le bouton d'achat (bloc « buy ») ou un lien vers une page produit compte comme clic CTA.
  state.clicks = state.clicks || [];
  var lastClick = 0;
  document.addEventListener('click', function (e) {
    // Un clic déclenché par le code du thème ou d'une app (isTrusted = false) n'est pas un geste du visiteur.
    if (!e.isTrusted) return;
    lastClick = Date.now();
    var t = e.target, sec = t.closest && t.closest(SEL);
    if (sec) {
      var path = [], n = t;
      while (n && n !== sec && path.length < 16) { path.unshift(Array.prototype.indexOf.call(n.parentNode.children, n)); n = n.parentNode; }
      var r = t.getBoundingClientRect(), sr = sec.getBoundingClientRect();
      var f = function (v) { return Math.round(Math.min(1, Math.max(0, v)) * 1000) / 1000; };
      state.clicks.push({
        k: sec.id.split('__').pop(), p: path.join('.'),
        rx: f(r.width ? (e.clientX - r.left) / r.width : 0.5), ry: f(r.height ? (e.clientY - r.top) / r.height : 0.5),
        sx: f((e.clientX - sr.left) / sr.width), sy: f((e.clientY - sr.top) / sr.height),
        l: t.closest('a') ? 1 : 0, x: (textOf(t.closest('a, button') || t) || t.getAttribute('alt') || t.tagName).slice(0, 50)
      });
      if (state.clicks.length > 60) state.clicks.shift();
      dirty = true;
    }
    // Header de la boutique (logo, menu, panier, langue, barre d'annonce ; bandeau logo de lpv2) : hors des sections
    // suivies sur une landing ou une fiche. Noté k: 'header', avec le temps actif (a) et le scroll (d) au moment du clic,
    // pour compter les sorties par le header et voir si ce sont des gens intéressés.
    var hdr = !sec && t.closest && t.closest('.shopify-section-group-header-group, header.topbar');
    if (hdr || (sec && sec.id.split('__').pop() === 'header')) {
      var la = t.closest('a');
      if (hdr) state.clicks.push({ k: 'header', p: '', rx: 0.5, ry: 0.5, sx: 0, sy: 0, l: la ? 1 : 0, x: (textOf(la || t.closest('button') || t) || (la && la.getAttribute('aria-label')) || t.getAttribute('alt') || t.tagName).slice(0, 50) });
      var last = state.clicks[state.clicks.length - 1];
      last.a = state.active_ms; last.d = +depthNow().toFixed(3);
      if (la) last.h = (la.getAttribute('href') || '').split('?')[0].slice(0, 80);
      if (state.clicks.length > 60) state.clicks.shift();
      dirty = true;
    }
    var a = TYPE === 'advertorial' && t.closest && t.closest('a');
    if (a && (a.classList.contains('adv-btn') || /\/products\//.test(a.getAttribute('href') || ''))) cta();
  }, true);

  function cta() {
    state.cta += 1;
    if (state.cta_ms === null) state.cta_ms = state.active_ms;
    send(true);
    // Sans panier existant au chargement, le marquage du début peut se perdre : le panier créé par l'ajout
    // arrive alors sans attributs et la commande n'est pas liée. On remarque le panier après chaque ajout.
    tagCart();
  }

  // Fiche : le bouton, c'est un ajout au panier réussi, peu importe le bouton ou l'app qui le fait
  // (fetch, XHR ou formulaire classique). Seulement dans les 5 s d'un clic : l'ajout automatique
  // du guide ou de la carte cadeau par le thème ne compte pas.
  if (TYPE !== 'advertorial') {
    var isAdd = function (url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); };
    var byUser = function () { return Date.now() - lastClick < 5000; };
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var r = origFetch.apply(this, arguments);
      try {
        if (isAdd(typeof input === 'string' ? input : input && input.url) && byUser()) {
          r.then(function (res) { if (res && res.ok) cta(); }, function () {});
        }
      } catch (e) {}
      return r;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      try {
        if (isAdd(url)) this.addEventListener('load', function () { if (this.status < 300 && byUser()) cta(); });
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && isAdd(f.getAttribute('action'))) setTimeout(function () { if (!e.defaultPrevented) cta(); }, 0);
    }, true);
  }

  var lastSent = 0;
  function payload() {
    set(SS, SKEY, JSON.stringify(state));
    var o = {}; for (var k in state) o[k] = state[k];
    o.layout = layout();
    return JSON.stringify(o);
  }
  function send(force) {
    if (!dirty && !force) return;
    dirty = false; lastSent = Date.now();
    var body = payload();
    if (force && navigator.sendBeacon) {
      try { if (navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
    }
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body, keepalive: true }).catch(function () {});
  }

  // Attributs cachés du panier (le _ les cache au client). La dernière visite d'advertorial avant l'achat l'emporte.
  // La promesse reste exposée : un bouton qui envoie au checkout tout de suite l'attend avant de quitter la page.
  function tagCart() {
    window.__suiviCartTag = fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _suivi_vid: vid, _suivi_sid: state.sid } }),
      __cartGuardBypass: true // le système de bonus panier du thème (theme.liquid) ignore cet appel
    }).catch(function () {});
  }

  function start() {
    tagCart();
    SECTIONS = sectionNodes();
    state.depth = Math.max(state.depth, +depthNow().toFixed(4));
    send(true);
    setInterval(tick, 1000);
    setInterval(function () { if (Date.now() - lastSent >= 10000) send(false); }, 2000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(true); });
    window.addEventListener('pagehide', function () { send(true); });
  }
  // Départ dès que le HTML est lu, sans attendre les images et vidéos (event load, très lent sur la landing dans le
  // navigateur intégré de Facebook). Les sections sont relues au load, quand leurs hauteurs sont finales.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { SECTIONS = sectionNodes(); dirty = true; });
})();
